const TOKEN_KEY = 'IAMMUSIC_TOKEN';

export const setToken = (token) => {
    localStorage.setItem(TOKEN_KEY, `bearer ${token}`);
}

export const getToken = () => {
    return localStorage.getItem(TOKEN_KEY);
}

export const removeToken = () => {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem("userId");
}

export const isLogin = () => {
    if (localStorage.getItem(TOKEN_KEY)) {
        return true;
    }

    return false;
}
export const setUserId = (userId) => {
    localStorage.setItem("userId", userId);
}
export const getUserId = () => {
    return localStorage.getItem("userId");
}